const Data = [
    {
        name: "Praneeth Reddy Kolanu",
        position: "Coordinator, PRAYAS ",
        imageUrl: "/assets/images/members/Heads21/Praneeth Reddy Kolanu.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Manusani Vaishnavi",
        position: "Coordinator, PRAYAS and Head, RISE",
        imageUrl: "/assets/images/members/Heads21/Manusani Vaishnavi.jpeg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Rajavardhini Bethala",
        position: "Head, PRAYAS and RISE",
        imageUrl: "/assets/images/members/Heads21/Rajavardhini Bethala.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Ratnesh Khandelwal",
        position: "Head, RISE",
        imageUrl: "/assets/images/members/Heads21/Ratnesh Khandelwal.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Surya Manikanta Tankala",
        position: "Head, PRAYAS",
        imageUrl: "/assets/images/members/Heads21/Surya Tankala.jpeg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    
]

export default Data;